import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { openConsentSettings } from '../../shared/privacy/consent';
import styles from './legal.module.css';

/** Privacy · Terms · Cookie settings - in the footers of the public pages and in Settings. */
export function LegalLinks({ className }: { className?: string }) {
  const { t } = useTranslation();
  return (
    <nav aria-label={t('legal.nav.label')} className={[styles.links, className].join(' ')}>
      <Link to="/privacy">{t('legal.nav.privacy')}</Link>
      <Link to="/terms">{t('legal.nav.terms')}</Link>
      <button type="button" className={styles.linkButton} onClick={openConsentSettings}>
        {t('legal.nav.cookies')}
      </button>
    </nav>
  );
}
